import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable, of, forkJoin } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ENV, IEnvironment, ApiResponse, ApiErrorResponse, ApiBanK } from '@shabic/models';
import { MediaService } from './media.service';

@Injectable({
  providedIn: 'root',
})
export class BankMediaService extends ApiBanK {
  override readonly url = '/bank/media';

  constructor(
    private http: HttpClient,
    @Inject(ENV) private env: IEnvironment,
    private mediaService: MediaService
  ) {
    super(env);
  }

  uploadMedia(files: File[]): Observable<ApiResponse<any>> {
    if (files.length === 0) {
      return of(new ApiResponse([]));
    }
    
    // Use direct HTTP to call /api/bank/media
    return this.uploadMediaDirect(files);
  }

    // Direct HTTP call to the bank media endpoint
  uploadMediaDirect(files: File[]): Observable<ApiResponse<any>> {
    if (files.length === 0) {
      return of(new ApiResponse([]));
    }

    const requests = files.map(file => {
      const formData = new FormData();
      formData.append('type', 'PRODUCT');
      formData.append('file', file);

      // Use the same pattern as ProductBankUploadService
      const endpoint = this.getEndpoint('');
      console.log('Bank Media Service Endpoint:', endpoint);
      return this.http.put<any>(endpoint, formData);
    });

    // Use forkJoin to handle multiple files
    return forkJoin(requests).pipe(
      map(responses => new ApiResponse(responses)),
      catchError(error => {
        console.error('Bank Media Upload Error:', error);
        return of(new ApiResponse(new ApiErrorResponse(error)));
      })
    );
  }
} 